const endpoints = {
  auth: "login",

  login: "login",
  sendOtp: "forget-password",
  verifyOtp: "verify-otp",
  resetPassword: "reset-password",

  getAllUser: "get-all-user",

  allContent: "get-all-content",
  updateContent: "updateContent",
  createContent: "createContent",

  getFaqs: "get-all-faq",
  editFaqs: "update-faq",
  deleteFaqs: "delete-faq",
  addFaq: "create-faq",

  getAllCards: "get-all-cards",
  editCardDetails: "update-card",
  deleteCardDetails: "card-delete",
  addCardDetails: "add-card",

  addThankYou: "create-thank-you-card",
  getThanksCard: "get-all-thank-you-cards",
  deleteThanksCard: "delete-thank-you-card",
  updateThankCard: "update-thank-you-card",
};

export default endpoints;
